import * as pdfjsLib from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker?url'

var pdfDoc = null,
    pageNum = 1,
    pageRendering = false,
    pageNumPending = null,
    scale = 0.8,
    canvas = null,
    ctx = null
var CSS_UNITS = 96/72;

var PdfGenerator = {
  renderPdf(pdfData) {
    import('pdfjs-dist').then(pdfjsLib => {
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker

      // Convert base64 string → Uint8Array
      const binaryString = atob(pdfData)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }

      const canvas = document.getElementById('the-canvas')
      const ctx = canvas.getContext('2d')

      let pdfDoc = null
      let pageNum = 1
      let pageRendering = false
      let pageNumPending = null
      const scale = 1.25

      function renderPage(num) {
        pageRendering = true
        pdfDoc.getPage(num).then(function (page) {
          const viewport = page.getViewport({ scale })
          canvas.height = viewport.height
          canvas.width = viewport.width

          const renderContext = {
            canvasContext: ctx,
            viewport,
            renderInteractiveForms: true
          }
          const renderTask = page.render(renderContext)

          renderTask.promise.then(function () {
            pageRendering = false
            if (pageNumPending !== null) {
              renderPage(pageNumPending)
              pageNumPending = null
            }
          })
        })

        // update UI counter
        const pageNumEl = document.getElementById('page_num')
        if (pageNumEl) pageNumEl.textContent = num
      }

      function queueRenderPage(num) {
        if (pageRendering) {
          pageNumPending = num
        } else {
          renderPage(num)
        }
      }

      function onPrevPage() {
        if (pageNum <= 1) return
        pageNum--
        queueRenderPage(pageNum)
      }

      function onNextPage() {
        if (pageNum >= pdfDoc.numPages) return
        pageNum++
        queueRenderPage(pageNum)
      }

      // Hook up buttons
      const prevBtn = document.getElementById('prev')
      if (prevBtn) prevBtn.addEventListener('click', onPrevPage)

      const nextBtn = document.getElementById('next')
      if (nextBtn) nextBtn.addEventListener('click', onNextPage)

      // Load PDF
      pdfjsLib.getDocument({ data: bytes }).promise.then(function (pdfDoc_) {
        pdfDoc = pdfDoc_
        const pageCountEl = document.getElementById('page_count')
        if (pageCountEl) pageCountEl.textContent = pdfDoc.numPages

        renderPage(pageNum)
      })
    })
  }
}

export default PdfGenerator


